import _ from "lodash";

export function isAdmin(utilisateur) {
    return _.get(utilisateur, "paramTypeUtilisateur.idParametre", "") === 263;
}